import FavoriteProduct from '../../data/getData-idb';
import {createHomeDetail} from '../../views/template/theme';

const ProductFav = {
  async render() {
    return `
        <div class="favorite-container" tabindex="0">
          <h2 class="favorite__label">Bookmarked</h2>
          <article id="favLists"></article>
        </div>
    `;
  },

  async afterRender() {
    const tryRenderFav = async () => {
      try {
        const restaurantContainer = document.querySelector('#favLists');
        restaurantContainer.classList.add('hidden');
        const loading = document.createElement('p');
        loading.textContent = 'Loading...';
        restaurantContainer.appendChild(loading);
        // Get all bookmarked restaurant
        const fav = await FavoriteProduct.getAllProducts();        
         setTimeout(() => {
          restaurantContainer.removeChild(loading);
          restaurantContainer.classList.remove('hidden');
          fav.forEach((restaurant) => {
            restaurantContainer.innerHTML += createHomeDetail(restaurant);
          });
        }, 1000);
        
      } catch (error) {
        const restaurantContainer = document.querySelector('#favLists');
        restaurantContainer.innerHTML = '<p>Failed to load bookmarked restaurant.</p>';
      }
    };
    tryRenderFav();
  },
};

export default ProductFav;
